import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  IoType,
  NodeSize,
  NodeType,
  NodeTypeCategory,
  NodeOperationIcon
} from "../Base";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.callCustomFieldsUpdate,
  label: "Update Custom Fields",
  operationIcon: NodeOperationIcon.update,
  category: NodeTypeCategory.services,
  size: NodeSize.Small,
  controlInputs: [{ name: "call" }],
  controlOutputs: [{ name: "completed", label: "" }],
  dataInputs: [],
  documentDataInputListName: "inputs",
  dataOutputs: [],
  nodeConfigProperties: [
    {
      name: "standardObjectId",
      label: "Standard Object",
      propertyType: NodeConfigPropertyType.StandardObject,
      schemaSourceSystemType: DocumentSchemaSource.customFieldsV1,
      schemaSystem: { createIo: true, ioType: IoType.update },
      options: { customFieldsOnly: true }
    },
    {
      name: "standardObjectName",
      label: "Standard Object Name",
      propertyType: NodeConfigPropertyType.NoInput,
      schemaSourceSystemType: DocumentSchemaSource.customFieldsV1
    },
    {
      name: "identifiers",
      sectionName: "Identifiers",
      propertyType: NodeConfigPropertyType.EnabledInputs
    },
    {
      name: "fields",
      sectionName: "Fields",
      propertyType: NodeConfigPropertyType.EnabledInputs
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const CallCustomFieldsUpdateNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  let label = "Update Custom Fields";
  if (data.nodeProperties.standardObjectName) {
    label = `Update ${data.nodeProperties.standardObjectName} Custom Fields`;
    data.nodeProperties.label = label;
  }
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
